import React, { useEffect, useState } from "react";

// Sub Components
import Navbar from "../../components/navigation/navbar";
import Footer from "../../components/navigation/footer";

// Helpers
import { setDocumentTitle } from "@hooks/document-title";

export default function NoAuth(props: Drivn.NoAuthProps) {
  // The State Of The Nav Menu
  const [menu, setMenu] = useState(false);

  // The React Component
  const { component: Component } = props;

  useEffect(() => {
    setDocumentTitle(props.title);
  });

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar open={menu} toggleOpen={setMenu} />
      <main
        style={{ marginTop: "-0px" }}
        className={`${menu ? "overflow-hidden" : ""} flex-1 overflow-x-hidden`}
      >
        <Component />
      </main>
      {!menu && <Footer />}
    </div>
  );
}
